<!-- <mat-card class="mat-elevation-z3" style="border-style: none;"> -->
  <div class="custom-card">
    <div class="custom-card-content">
      <button
        mat-button
        *ngFor="let item of customPresets"
        color="primary"
        class="preset-button"
        (click)="selectRange(item)"
        [class.selected]="item == selectedRange"
      >
        {{ item }}
      </button>
    </div>
    <!-- <div class="custom-card-footer">
      <button (click)="save()">Save Filter</button>
    </div> -->
    <!-- </mat-card> -->
  </div>
  